module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-7.8a5092e1.jpg";